const year_wages = {
    number_of_periods: 2,
    1992: [
            {middle: 30417,high: 0},
            {middle: 30843,high: 0}
    ],
    1993:[
            {middle:0,high:0},
            {middle:0,high:0}
    ],
    1994:[
            {middle:0,high:0},
            {middle:0,high:0}
    ],
    1995:[
            {middle:0,high:0},
            {middle:0,high:0}
    ],
    1996:[
            {middle:27715,high:31174},
            {middle:28103,high:31610}
    ],
    1997:[
            {middle:26908,high:31174},
            {middle:27285,high:31610}
    ],
    1998:[
            {middle:26435,high:30305},
            {middle:26805,high:30729}
    ],
    1999:[
            {middle:25798,high:29133},
            {middle:26159,high:29541}
    ],
    2000:[
            {middle:24968,high:28055},
            {middle:25318,high:28448}
    ],
    2001:[
            {middle:0,high:0},
            {middle:0,high:0}
    ],
    2002:[
            {middle:23708,high:26580},
            {middle:24040,high:26952}
    ],
    2003:[
            {middle:0,high:0},
            {middle:0,high:0}
    ],
    2004:[
            {middle:0,high:0},
            {middle:0,high:0}
    ],
    2005:[
            {middle:22164,high:24478},
            {middle:22474,high:24821}
    ],
    2006:[
            {middle:21672,high:23846},
            {middle:21975,high:24180}
    ],
    2007:[
            {middle:21226,high:23426},
            {middle:21523,high:23754}
    ],
    2008:[
            {middle:20763,high:23003},
            {middle:21054,high:23325}
    ],
    2009:[
            {middle:20339,high:22656},
            {middle:20624,high:22973}
    ],
    2010:[
            {middle:20060,high:22233},
            {middle:20341,high:22544}
    ],
    2011:[
            {middle:19848,high:21998},
            {middle:20126,high:22306}
    ],
    2012:[
            {middle:19151,high:21237},
            {middle:19419,high:21534}
    ],
    2013:[
            {middle:18712,high:20686},
            {middle:18974,high:20976}
    ],
    2014:[
            {middle:18272,high:20139},
            {middle:18528,high:20421}
    ],
    2015:[
            {middle:17833,high:19645},
            {middle:18083,high:19920}
    ],
    2016:[
            {middle:17305,high:19086},
            {middle:17547,high:19353}
    ],
    2017:[
            {middle:16832,high:18566},
            {middle:17068,high:18826}
    ],
    2018:[
            {middle:16600,high:18300},
            {middle:16832,high:18556}
    ],
}

const brp_bonus_wages_old = {
    0: {
        titulo: 0,
        mencion: 0
    },
    1: {
        titulo: 2259,
        mencion: 753
    },
    2: {
        titulo: 4518,
        mencion: 1506
    },
    3: {
        titulo: 6776,
        mencion: 2259
    },
    4: {
        titulo: 9035,
        mencion: 3012
    },
    5: {
        titulo: 11294,
        mencion: 3765
    },
    6: {
        titulo: 13553,
        mencion: 4518
    },
    7: {
        titulo: 15812,
        mencion: 5271
    },
    8: {
        titulo: 18070,
        mencion: 6024
    },
    9: {
        titulo: 20329,
        mencion: 6777
    },
    10: {
        titulo: 22588,
        mencion: 7530
    },
    11: {
        titulo: 24847,
        mencion: 8283
    },
    12: {
        titulo: 27106,
        mencion: 9036
    },
    13: {
        titulo: 29364,
        mencion: 9789
    },
    14: {
        titulo: 31623,
        mencion: 10542
    },
    15: {
        titulo: 33882,
        mencion: 11295
    },
    16: {
        titulo: 36141,
        mencion: 12047
    },
    17: {
        titulo: 38400,
        mencion: 12800
    },
    18: {
        titulo: 40658,
        mencion: 13553
    },
    19: {
        titulo: 42917,
        mencion: 14306
    },
    20: {
        titulo: 45176,
        mencion: 15059
    },
    21: {
        titulo: 47435,
        mencion: 15812
    },
    22: {
        titulo: 49694,
        mencion: 16565
    },
    23: {
        titulo: 51952,
        mencion: 17318
    },
    24: {
        titulo: 54211,
        mencion: 18071
    },
    25: {
        titulo: 56470,
        mencion: 18824
    },
    26: {
        titulo: 58729,
        mencion: 19577
    },
    27: {
        titulo: 60988,
        mencion: 20330
    },
    28: {
        titulo: 63246,
        mencion: 21083
    },
    29: {
        titulo: 65505,
        mencion: 21836
    },
    30: {
        titulo: 67764,
        mencion: 22589
    },
    31: {
        titulo: 67764,
        mencion: 22589
    },
    32: {
        titulo: 67764,
        mencion: 22589
    },
    33: {
        titulo: 67764,
        mencion: 22589
    },
    34: {
        titulo: 67764,
        mencion: 22589
    },
    35: {
        titulo: 67764,
        mencion: 22589
    },
    36: {
        titulo: 67764,
        mencion: 22589
    },
    37: {
        titulo: 67764,
        mencion: 22589
    },
    38: {
        titulo: 67764,
        mencion: 22589
    },
    39: {
        titulo: 67764,
        mencion: 22589
    },
    40: {
        titulo: 67764,
        mencion: 22589
    },
    41: {
        titulo: 67764,
        mencion: 22589
    },
    42: {
        titulo: 67764,
        mencion: 22589
    },
    43: {
        titulo: 67764,
        mencion: 22589
    },
    44: {
        titulo: 67764,
        mencion: 22589
    },

}

const brp_bonus_wages = {
    0: {
        titulo: 0,
        mencion: 0
    },
    1: {
        titulo: 2338,
        mencion: 779
    },
    2: {
        titulo: 4676,
        mencion: 1559
    },
    3: {
        titulo: 7014,
        mencion: 2338
    },
    4: {
        titulo: 9351,
        mencion: 3117
    },
    5: {
        titulo: 11689,
        mencion: 3897
    },
    6: {
        titulo: 14027,
        mencion: 4676
    },
    7: {
        titulo: 16365,
        mencion: 5455
    },
    8: {
        titulo: 18703,
        mencion: 6235
    },
    9: {
        titulo: 21041,
        mencion: 7014
    },
    10: {
        titulo: 23379,
        mencion: 7793
    },
    11: {
        titulo: 25717,
        mencion: 8573
    },
    12: {
        titulo: 28054,
        mencion: 9352
    },
    13: {
        titulo: 30392,
        mencion: 10131
    },
    14: {
        titulo: 32730,
        mencion: 10911
    },
    15: {
        titulo: 35068,
        mencion: 11690
    },
    16: {
        titulo: 37046,
        mencion: 12469
    },
    17: {
        titulo: 39744,
        mencion: 13249
    },
    18: {
        titulo: 42082,
        mencion: 14028
    },
    19: {
        titulo: 44419,
        mencion: 14807
    },
    20: {
        titulo: 46757,
        mencion: 15587
    },
    21: {
        titulo: 49095,
        mencion: 16366
    },
    22: {
        titulo: 51433,
        mencion: 17145
    },
    23: {
        titulo: 53771,
        mencion: 17925
    },
    24: {
        titulo: 56109,
        mencion: 18704
    },
    25: {
        titulo: 58447,
        mencion: 19483
    },
    26: {
        titulo: 60785,
        mencion: 20263
    },
    27: {
        titulo: 63122,
        mencion: 21042
    },
    28: {
        titulo: 65460,
        mencion: 21821
    },
    29: {
        titulo: 67798,
        mencion: 22601
    },
    30: {
        titulo: 70136,
        mencion: 23380
    },
    31: {
        titulo: 70136,
        mencion: 23380
    },
    32: {
        titulo: 70136,
        mencion: 23380
    },
    33: {
        titulo: 70136,
        mencion: 23380
    },
    34: {
        titulo: 70136,
        mencion: 23380
    },
    35: {
        titulo: 70136,
        mencion: 23380
    },
    36: {
        titulo: 70136,
        mencion: 23380
    },
    37: {
        titulo: 70136,
        mencion: 23380
    },
    38: {
        titulo: 70136,
        mencion: 23380
    },
    39: {
        titulo: 70136,
        mencion: 23380
    },
    40: {
        titulo: 70136,
        mencion: 23380
    },
    41: {
        titulo: 70136,
        mencion: 23380
    },
    42: {
        titulo: 70136,
        mencion: 23380
    },
    43: {
        titulo: 70136,
        mencion: 23380
    },
    44: {
        titulo: 70136,
        mencion: 23380
    },

}

export {year_wages, brp_bonus_wages}


// WEBPACK FOOTER //
// ./src/components/home/wages.js